"use client";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { FamousInvestorIndex } from "../data/types";
import { useFamousInvestorStatus } from "../services/famous-investor-status";
import { getActiveIndex } from "../utils/get-active-index";
import { getInvestorLists } from "../utils/get-investor-list";

type Props = {
  symbol: string;
  famous: FamousInvestorIndex;
};

export const FamousInvestorSelect = ({ symbol, famous }: Props) => {
  const { updateQuery } = useUpdateQuery();
  const { data } = useFamousInvestorStatus(symbol);
  const investorList = getInvestorLists(data?.data);
  const activeIndex = getActiveIndex({ famous, investorList });

  return (
    <div className="md:hidden">
      <select
        className="ml-auto block w-full max-w-xs rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600"
        onChange={(e) => {
          updateQuery({
            name: "famous",
            value: e.target.selectedIndex.toString(),
          });
        }}
        defaultValue={investorList[activeIndex]?.investorName ?? ""}
      >
        {investorList.map((option) => (
          <option disabled={option.isDisable} key={option.investorName}>
            {option.investorName}
          </option>
        ))}
      </select>
    </div>
  );
};
